module.exports = __webpack_public_path__ + "assets/img/benefit-free-order-23d585e0.png";